// Web Audio API Synthesizer for UI Effects
// This creates sounds dynamically without needing external audio files, ensuring 0 loading times.

let audioCtx: AudioContext | null = null;

const initAudio = () => {
  if (!audioCtx) {
    const Ctx = window.AudioContext || (window as any).webkitAudioContext;
    if (Ctx) {
      audioCtx = new Ctx();
    }
  }
};

export const playCartSwoosh = () => {
  try {
    initAudio();
    if (!audioCtx) return;

    // Resume context if suspended (browser auto-play policies)
    if (audioCtx.state === 'suspended') {
      audioCtx.resume();
    }

    const t = audioCtx.currentTime;

    // 1. Soft, Low, Soothing Swoosh
    const swooshOsc = audioCtx.createOscillator();
    const swooshGain = audioCtx.createGain();
    
    // Use a very soft sine wave
    swooshOsc.type = 'sine';
    // Start low, end even lower for a muffled, bassy feel
    swooshOsc.frequency.setValueAtTime(300, t);
    swooshOsc.frequency.exponentialRampToValueAtTime(60, t + 0.4);

    // Gentle volume envelope (very quiet max volume of 0.05)
    swooshGain.gain.setValueAtTime(0, t);
    swooshGain.gain.linearRampToValueAtTime(0.05, t + 0.15); // gentle fade in
    swooshGain.gain.exponentialRampToValueAtTime(0.001, t + 0.4); // smooth fade out

    swooshOsc.connect(swooshGain);
    swooshGain.connect(audioCtx.destination);

    swooshOsc.start(t);
    swooshOsc.stop(t + 0.45);

  } catch (error) {
    // Silently fail if audio API is blocked by browser policies
    console.warn('Web Audio API failed to play sound', error);
  }
};
